export default __webpack_public_path__ + "static/media/img_nav-bg.4fcba3e5.png";